module.exports = __webpack_public_path__ + "static/eatseverything_3-51a911d86f91a0e8c8febd1964cf633f.jpg";